import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import GeneralDropdownsDropdownArrowButton from 'lumen/components/general/dropdowns/dropdown-arrow-button';

interface GeneralListsCtaExpandToggleSignature {
  Args: {};
}

const GeneralListsCtaExpandToggle = <template>
  {{! @glint-nocheck: not typesafe yet }}
  {{#unless this.isLoading}}
    <div class="expand-toggle">
      {{t "general.details"}}
      <GeneralDropdownsDropdownArrowButton
        @isOpen={{this.isExpanded}}
        @onClick={{this.openExpandView}}
      />
    </div>
  {{/unless}}
</template> satisfies TOC<GeneralListsCtaExpandToggleSignature>;

export default GeneralListsCtaExpandToggle;
